@if (readonly()) {
  @let value = ngControl.control.value;
  @if (value == null) {
    -
  } @else {
    @switch (type()) {
      @case ("currency") {
        {{ value | currency: "GBP" : "symbol" : "1.0-" + (maxFractionDigits() ?? 0) }}
      }
      @case ("percent") {
        {{ value }}%
      }
      @default {
        {{ value }}
      }
    }
  }
} @else if (ngControl.control != null) {
  @switch (type()) {
    @case ("currency") {
      <p-inputNumber
        class="input-number"
        locale="en-GB"
        mode="currency"
        currency="GBP"
        [name]="name()"
        [min]="min()"
        [max]="max()"
        (onInput)="onChange.emit($event)"
        [maxFractionDigits]="maxFractionDigits() ?? 0"
        [placeholder]="placeholder() ?? '£'"
        [formControl]="(ngControl.control | abstractControlToFormControl)!"
        [format]="formatNumber()" />
    }
    @case ("percent") {
      <p-inputNumber
        class="input-number"
        [name]="name()"
        [min]="min() ?? 0"
        [max]="max() ?? 100"
        (onInput)="onChange.emit($event)"
        [minFractionDigits]="minFractionDigits() ?? 0"
        [maxFractionDigits]="maxFractionDigits() ?? 0"
        [placeholder]="placeholder() ?? '%'"
        suffix="%"
        [formControl]="ngControl.control | abstractControlToFormControl"
        [format]="formatNumber()"
        [useGrouping]="false" />
    }
    @case ("plain-number") {
      <p-inputNumber
        class="input-number"
        [name]="name()"
        [min]="min()"
        [max]="max()"
        (onInput)="onChange.emit($event)"
        [maxFractionDigits]="maxFractionDigits()"
        [placeholder]="placeholder()"
        [suffix]="suffix()"
        [formControl]="ngControl.control | abstractControlToFormControl"
        [format]="formatNumber()" />
    }
  }
}
